export default __webpack_public_path__ + "static/media/Pixentro1.c98388a8.png";